import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { useGraphData } from './util/useGraphData'
import { Homepage } from './components/pages/Homepage'
import { Instructions } from './components/pages/Instructions'
import { Collections } from './components/pages/Collections'
import { Footer } from './components/footer/Footer'
import { Header } from './components/header/Header'
import { CategoryCollection, TopicCollection } from './components/pages/StoryCollection'
import { Endpage } from './components/pages/Endpage'
import { VideosPage } from './components/pages/VideosPage'
import { navigationConfig } from './util/navigation'

function App() {
  const { collectionsData, pagesData, error } = useGraphData()

  if (error) {
    console.error(error)
    return <p> Oops something went wrong </p>
  }

  function getElement(id: string) {
    switch (id) {
      case 'home':
        return <Homepage data={pagesData?.pages?.find((page) => page.slug === id)} />
      case 'instructions':
        return <Instructions data={pagesData?.pages?.find((page) => page.slug === id)} />
      case 'takeaways':
        return <Endpage data={pagesData?.pages?.find((page) => page.slug === id)} />
      case 'collections':
        return <Collections data={collectionsData} />
      case 'videos':
        return <VideosPage />
      default:
        return null
    }
  }

  return (
    <Router>
      <main>
        <Header data={pagesData?.pages} />

        <Routes>
          {/* Hardcoded navigation routes */}
          {
            navigationConfig.map((item) => {
              return (
                <Route
                  path={item.path}
                  element={getElement(item.id)}
                  key={item.id}
                />
              )
            })
          }


          {/* Category and Topic routes */}
          <Route
            path='/topic/:slug'
            element={<TopicCollection collectionsData={collectionsData} />}
          />
          <Route
            path='/category/:slug'
            element={<CategoryCollection collectionsData={collectionsData} />}
          />
        </Routes>
      </main>

      <Footer />
    </Router>
  )
}

export { App }
